export class PriceMatrixFilter {

  order = 'ASC';
  brand: number;
  year = 2022;
  page = 0;
  pageSize = 20;
  orderBy = 'CATEGORY';
}
